<template>
    <app-simulation class="ui wide text container" ref="app" id="app-container">
        <app-report v-if="project" :project="project">
        </app-report>
        <div v-else class="ui simulation very basic segment">
            <div class="ui small form">
                <ui-accordion ref="accordion">
                    <app-scope v-for="(project, identifier, index) in $store.state.project"
                        :key="project.id" @estimate="onEstimateVariable"
                        @toggle="onLoadProject($event, project)"
                        @change="onChangeScope"
                        :model="project"
                        :default="index == 0"
                    >
                        <template v-slot:children="project">
                            <ui-accordion variant="styled">
                                <app-scope v-for="(building, index) of $store.getters.children(project.scope)"
                                    :key="building.id"
                                    @estimate="onEstimateVariable"
                                    @change="onChangeScope"
                                    :model="building"
                                    :default="index == 0"
                                    :variant="{size: 'small', background: 'light blue', color: 'inverted'}"
                                    :parentCurrency="project.scope.attributes.currency"
                                >
                                    <template v-slot:children="building">
                                        <ui-accordion variant="styled">
                                            <app-scope v-for="(shaft, index) of $store.getters.children(building.scope)"
                                                :key="shaft.id"
                                                @estimate="onEstimateVariable"
                                                @change="onChangeScope"
                                                :model="shaft"
                                                :default="index == 0" :variant="{size: 'small', background: 'grey'}"
                                                :parentCurrency="project.scope.attributes.currency"
                                            >
                                            </app-scope>
                                        </ui-accordion>
                                    </template>
                                    <template v-slot:actions="building">
                                        <div class="ui basic segment" v-if="!isLocked">
                                            <a href="#" @click.prevent="$store.dispatch('create', building.scope)"><i class="plus circle icon"></i>{{ $t('scopes.shaft.actions.create') }}</a>
                                        </div>
                                    </template>
                                </app-scope>
                            </ui-accordion>
                        </template>
                        <template v-slot:actions="project">
                            <div class="ui basic segment" v-if="!isLocked">
                                <a href="#" @click.prevent="$store.dispatch('create', project.scope)"><i class="plus circle icon"></i>{{ $t('scopes.building.actions.create') }}</a>
                            </div>
                            <div class="ui secondary segment">
                                <div class="ui equal width middle aligned grid">
                                    <div class="right aligned column">
                                        <button class="ui button" :disabled="project.scope.attributes.status === 'INCOMPLETE'" @click="onShowReport($event, project)">{{ $t('scopes.project.actions.calculate') }}</button>
                                    </div>
                                </div>
                            </div>
                        </template>
                    </app-scope>
                </ui-accordion>
            </div>
            <div class="ui vertical segment" v-if="!isLocked">
                <a href="#" @click.prevent="onCreateProject"><i class="plus circle icon"></i> {{ $t('scopes.project.actions.create') }}</a>
            </div>
        </div>
        <ui-modal id="basic">
            <template v-slot="modal">
                <div class="content">
                    <div class="description">
                        <p>{{ modal.model.message }}</p>
                    </div>
                </div>
                <div class="actions">
                    <div class="ui tiny negative cancel right labeled icon button" @click="modal.actions.cancel()">
                        {{ $t('components.modal.actions.cancel') }}
                        <i class="close site icon"></i>
                    </div>
                    <div class="ui tiny positive right labeled icon button" @click="modal.actions.close()">
                        {{ $t('components.modal.actions.okay') }}
                        <i class="checked site icon"></i>
                    </div>
                </div>
            </template>
        </ui-modal>
    </app-simulation>
</template>

<script>
import AppReport from './components/AppReport.vue'
import AppScope from './components/AppScope.vue'

import UiAccordion from './components/UiAccordion.vue'
import UiModal from './components/UiModal.vue'

import Bus from './Bus.js'
import Profile from './Profile.js'
import Validation from './Validation.js'
import { Mixin as GtagConversionMixin } from './util/gtag-conversion'

export default {
    name: 'App',
    mixins: [Validation, GtagConversionMixin],
    components: {
        AppReport,
        AppScope,
        UiAccordion,
        UiModal
    },
    data() {
        return {
            project: null
        }
    },
    async created() {
        await this.$store.dispatch('initialize')
        this.$refs.accordion.activate(this.$refs.accordion.items.length)
    },
    computed: {
        isLocked() {
            return this.$store.state.profile !== Profile.extended
        }
    },
    methods: {
        onChangeScope(event) {
            this.$queue.enqueue(async () => {
                Bus.$emit('change', {
                    ...event.variable
                })

                if (event.errors.length > 0) {
                    console.error(event.errors)
                    return
                }
            })
        },
        onEstimateVariable(event) {
            this.$queue.enqueue(async () => {
                this.$store.dispatch('refresh', event.variable.scope)
            })
        },
        onLoadProject(event, scope) {
            const dispatch = async () => {
                if (event.active) {
                    await this.$store.dispatch('fetch', scope)
                }
            }

            if (!event.active) {
                return
            }

            event.waitUntil(dispatch())
        },
        onShowReport(event, project) {
            const dispatch = async () => {
                await this.$store.dispatch('fetch', project.scope)
                this.project = project
                this.conversion('calculate')
            }

            
            window.scrollTo(0, 0)   
            document.getElementById("app-container").scrollIntoView()

            event.waitUntil(dispatch())
        },
        async onCreateProject() {
            await this.$store.dispatch('create')
                this.$refs.accordion.activate(this.$refs.accordion.items.length)
        }
    }
}
</script>